import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import ExecutiveDashboard from '@/components/ExecutiveSummary/ExecutiveDashboard.vue';
import TeamDashboard from '@/components/TeamDashboard/TeamDashboard.vue';
import { getCookie, get_token } from '@/router/index.js';

import complyon from '@/assets/create_images/company.png';
import engagenet from '@/assets/create_images/community.png';
import orcaa from '@/assets/create_images/orcaa.png';
import xverdict from '@/assets/create_images/case.png';

export default {
  name: 'HomeView',
  components: { Sidebar, Navbar, ExecutiveDashboard, TeamDashboard },
  data: () => ({
    ai_open: false,
    csrfToken: '',
    audits: [],
    upcoming_events: [],
    pending_approvals: 0,
    notifications: [],
    notification_count: 0,
    active_dashboard_mode: "my",
    user: {
      name: 'Loading...',
      tenant: 'AI Campus',
      role: [],
    },
    user_first_name: 'there',
    team_data: {
        name: 'N/A',
        lead: 'N/A',
        member_count: 0,
        sprint: 0,
        week: 0,
        total_weeks: 0
    },
    cardImages: {
        engagenet: engagenet,
        orcaa: orcaa,
        xverdict: xverdict,
        complyon: complyon,
    },
    recent_activity: [
      { t: '2 mins ago', d: 'Proba job completed - ESG-ETL pipeline finished in 6m 21s' },
      { t: '15 mins ago', d: 'ComplyOn workflow submitted - Tenant KYC with 3 pending approvals' },
      { t: '1 hour ago', d: 'EngageNet post created - Data governance quick tips with 12 replies' },
      { t: '3 hours ago', d: 'AIC Trail sync completed - 432 audit events processed in last 24h' },
    ],
    used_gb: '',
    total_gb: '',
    available_gb: '',
    percentage_used: '',
    courses: [],
    courses_summary:0,
    courses_loading: false,

    //probaworkflows
    pending_requests: 0,
    pending_requests_list: [],
    pending_requests_loading: true,

    // Task tracking
    tasks: [],
    tasks_loading: false,
    assigned_tasks_count: 0,
    overdue_tasks_count: 0,
    active_tasks: 0,
    completed_this_week: 0,

    has_audit_permission: true,
    audits_loading: false,

    // Case tracking
    cases: [],
    cases_loading: false,
    pending_cases: 0,
  }),
  computed: {
    can_view_my_dashboard() {
      const has_access = true; // All users can see their personal dashboard
      return has_access;
    },

    can_view_team_dashboard() {
      if (!this.user || !this.user.role || !Array.isArray(this.user.role)) {
        return false;
      }
      const allowed_roles = ['org_admin', 'system_admin', 'portal_admin'];

      return this.user.role.some(role => allowed_roles.includes(role));
    },

    can_view_executive_dashboard() {
      // Safety checks
      if (!this.user || !this.user.role || !Array.isArray(this.user.role) || this.user.role.length === 0) {
        return false;
      }

      const has_access = this.user.role.includes('system_admin');

      return has_access;
    },

    available_dashboards() {
      const dashboards = [];

      // Use try-catch to handle any unexpected errors
      try {
        if (this.can_view_my_dashboard) {
          dashboards.push('my');
        }

        if (this.can_view_team_dashboard) {
          dashboards.push('team');
        }

        if (this.can_view_executive_dashboard) {
          dashboards.push('executive');
        }
      } catch (error) {
        // Fallback: everyone can at least see 'my' dashboard
        return ['my'];
      }

      return dashboards.length > 0 ? dashboards : ['my'];
    },

    default_dashboard() {
      let default_dashboard = 'my';

      try {
        // Priority: executive > team > my
        if (this.can_view_executive_dashboard) {
          default_dashboard = 'executive';
        } else if (this.can_view_team_dashboard) {
          default_dashboard = 'team';
        } else if (this.can_view_my_dashboard) {
          default_dashboard = 'my';
        }
      } catch (error) {
        default_dashboard = 'my'; // Safe fallback
      }

      return default_dashboard;
    },

    user_role_display() {
      if (!this.user || !this.user.role || !Array.isArray(this.user.role) || this.user.role.length === 0) {
        return 'User';
      }

      const role_display_map = {
        'system_admin': 'Super Admin',
        'org_admin': 'Organization Admin',
        'user': 'User',
      };

      // Return the highest privilege role for display
      if (this.user.role.includes('system_admin')) {
        return role_display_map['system_admin'];
      } else if (this.user.role.includes('org_admin')) {
        return role_display_map['org_admin'];
      }else if (this.user.role.includes('portal_admin')) {
        return 'Portal Administrator';
      } else {
        return role_display_map['user'];
      }
    },

    dashboard_greeting() {
      const hour = new Date().getHours();

      if (hour < 12) {
        return 'Good morning';
      }

      if (hour < 17) {
        return 'Good afternoon';
      }

      return 'Good evening';
    },

    dashboard_summary() {
      const approvals = Number(this.pending_approvals) || 0;
      const events = Array.isArray(this.upcoming_events) ? this.upcoming_events.length : 0;

      return `${this.approval_summary(approvals)} and ${this.event_summary(events)}`;
    },

    recent_from_audits() {
      if (Array.isArray(this.audits) && this.audits.length) {
        return this.audits
          .slice(0, 4)
          .map(this.map_audit_to_row)
          .filter(Boolean);
      }
      return this.recent_activity;
    },
    desktop_top_metrics() {
      return [
        { label: 'Active Tasks', value: this.active_tasks, icon: 'fa-solid fa-clipboard-list', color: '#3498db' },
        { label: 'Completed This Week', value: this.completed_this_week, icon: 'fa-solid fa-circle-check', color: '#2ecc71' },
        { label: 'Pending Requests', value: this.pending_requests, icon: 'fa-solid fa-clock', color: '#f39c12' },
        { label: 'Documents Approvals', value: this.pending_approvals, icon: 'fa-solid fa-file-alt', color: '#9b59b6' },
      ];
    },

    mobile_top_metrics() {
      return this.desktop_top_metrics.map(metric => ({
        ...metric,
        short_label: {
          'Active Tasks': 'Active',
          'Completed This Week': 'Completed',
          'Pending Requests': 'Requests',
          'Documents Approvals': 'Approvals',
        }[metric.label] || metric.label,
      }));
    },

    mobile_team_metrics() {
      return this.key_metrics.map(metric => ({
        ...metric,
        short_label: {
          'Active Tasks': 'Active',
          'Team Utilization': 'Utilization',
          'Overdue Tasks': 'Overdue',
          'Team Health Score': 'Health',
        }[metric.label] || metric.label,
      }));
    },

    executive_kpis () {
      return [
      {
        label: 'Annual Revenue',
        value: 'R 20M',
        change: '+18.5% vs last quarter',
        positive: true,
        icon: 'fa-solid fa-chart-line',
        color: '#3498db'
      },
      {
        label: 'Team Size',
        value: '52 Employees',
        change: '+3.8% YoY acceleration',
        positive: true,
        icon: 'fa-solid fa-arrow-trend-up',
        color: '#2ecc71',
      },
      {
        label: 'Active Products',
        value: '6',
        change: '+12.4% efficiency gain',
        positive: true,
        icon: 'fa-solid fa-users',
        color: '#f39c12'
      },
      {
        label: 'Reporting Period',
        value: '2026',
        change: '+8.5% needs optimization',
        positive: false,
        icon: 'fa-solid fa-bullseye',
        color: '#9b59b6'
      }
    ]},

    key_metrics() {
      const m = (this.engagenet_raw_data && this.engagenet_raw_data.metrics)
                ? this.engagenet_raw_data.metrics
                : {};

      return [
        { label: 'Active Tasks',value: m.total_active ?? 0, icon: 'fa-solid fa-clipboard-list', color: '#3498db' },
        { label: 'Team Utilization', value: m.avg_utilization !== undefined ? m.avg_utilization + '%' : '0%', icon: 'fa-solid fa-bolt', color: '#2ecc71'},
        { label: 'Overdue Tasks', value: m.total_overdue ?? 0, icon: 'fa-solid fa-fire', color: '#f39c12'},
        { label: 'Team Health Score', value: m.health_score !== undefined ? m.health_score + '/10' : '0/10', icon: 'fa-solid fa-heart-pulse', color: '#9b59b6' }
      ];
    },
  },

  mounted() {
    this.csrfToken = getCookie("csrftoken");
    this.load_user_details();
    this.fetch_audits();
    this.fetch_engagenet_events()
    this.update_progress_bar();
    this.fetch_storage_stats();
    this.fetch_user_tasks();
    this.fetch_user_courses();
    this.fetch_engagenet_document_approvals();
    this.fetch_engagenet_notifications();
    this.fetch_pending_requests();
    this.fetch_user_cases();
  },

  watch: {
    percentage_used() {
      this.update_progress_bar();
    },

    'user.role': {
      handler() {
        const available_dashboard = this.available_dashboards;

        if (!Array.isArray(available_dashboard) || available_dashboard.length === 0) {
          return;
        }

        if (!available_dashboard.includes(this.active_dashboard_mode)) {
          this.active_dashboard_mode = this.default_dashboard;
        }
      },
      deep: true,
      immediate: false
    },
  },


  methods: {
    approval_summary(count) {
      if (count === 0) {
        return 'no documents need your approval';
      }

      return `${count} ${count === 1 ? 'document needs' : 'documents need'} your approval`;
    },

    event_summary(count) {
      if (count === 0) {
        return 'no events are coming up';
      }

      return `${count} ${count === 1 ? 'event is' : 'events are'} coming up`;
    },

    set_dashboard_mode(mode) {

      // Validate mode parameter
      const valid_modes = ['my', 'team', 'executive'];
      if (!valid_modes.includes(mode)) {
        this.$notyf.error('Invalid dashboard selection');
        return;
      }

      // Permission granted - switch dashboard
      this.active_dashboard_mode = mode;
      this.$notyf.success(`Switched to ${mode === 'my' ? 'My' : mode === 'team' ? 'Team' : 'Executive'} Overview`);
    },

    format_status(status) {
      if (!status) {
        return 'Assigned';
      }

      return String(status)
        .replace(/_/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
    },

    status_badge_class(status) {
      const normalized = String(status || '').toLowerCase();

      return Reflect.get(
        {
          overdue: 'bg-danger-subtle text-danger',
          completed: 'bg-success-subtle text-success',
          in_progress: 'bg-primary-subtle text-primary',
        },
        normalized
      ) || 'bg-light text-dark';
    },

    course_status_badge_class(status) {
      const normalized = String(status || '').toLowerCase();

      return Reflect.get(
        {
          completed: 'bg-success text-white',
          'in progress': 'bg-info text-dark',
          paused: 'bg-warning text-dark',
        },
        normalized
      ) || 'bg-light text-dark';
    },

    case_title(case_item) {
      return this.first_present_value(
        case_item,
        ['title', 'case_title', 'case_name', 'name', 'reference', 'case_number'],
        'Case'
      );
    },

    case_status(case_item) {
      return case_item?.status || case_item?.case_status || case_item?.state || 'in progress';
    },

    case_date(case_item) {
      const value = this.first_present_value(
        case_item,
        ['date_created', 'created_at', 'updated_at', 'date'],
        null
      );

      return this.format_date(value) || 'No date available';
    },

    async load_user_details() {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_current_user/`;
      const token = get_token();
      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          const user_data = response_data.data;

          this.user.first_name = user_data.first_name || '';
          this.user.last_name = user_data.last_name || '';
          this.user.name = `${user_data.first_name} ${user_data.last_name}`;
          this.user_first_name = user_data.first_name || 'there';
          this.user.tenant = user_data.tenant || 'AI Campus';

          const role_mapping = {
            'Super Admin': ['system_admin'],
            'Organization Admin': ['org_admin'],
            'Org Admin': ['org_admin'],
            'Portal Admin': ['portal_admin'],
            'User': ['user'],
          };

          this.user.role = Reflect.has(role_mapping, user_data.role)
            ? Reflect.get(role_mapping, user_data.role)
            : ['user'];

          if (this.can_view_team_dashboard || user_data.role === 'User') {
              await this.fetch_team_performance_data();
          }
        }
      } catch (error) {
        this.$notyf.info('Error fetching user details');
      }
    },

    async fetch_team_performance_data() {
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_team_performance_metrics/`;

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrfToken,
          },
          body: JSON.stringify({})
        });

        const json = await response.json();

        if (json.status === "success") {
          this.engagenet_raw_data = json;

          this.team_data = {
            name: json.portal_name,
            lead: json.admin_user
          };

          const local_name = this.user.name.toLowerCase().trim();
          const engagenet_admin = json.admin_user.toLowerCase().trim();

          if (local_name === engagenet_admin) {
            if (!this.user.role.includes('portal_admin')) {
              this.user.role.push('portal_admin');
            }
          }
        }
      } catch (error) {
        console.error("Portal Data Integration Error:", error);
      }
    },

    async fetch_audits() {
      this.audits_loading = true;
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_all_audits/`;
      const token = get_token();

      try {
        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${token}`,
            "X-CSRFToken": this.csrfToken,
          },
        });

        if (!res.ok) {
          // Check for permission denied
          if (res.status === 403) {
            this.has_audit_permission = false;
            this.audits_loading = false;
            return;
          }

          const data = await res.json();
          console.error(data.message || `Failed to fetch audits: HTTP ${res.status}`);
          this.audits_loading = false;
          return;
        }

        const data = await res.json();
        if (res.ok && data.status === "success") {
          this.audits = Array.isArray(data.data) ? data.data : [];
          this.has_audit_permission = true;
        } else {
          console.error("Error fetching audits:", data.message || "Unknown error");
        }
      } catch (err) {
        console.error("Network error:", err);
      } finally {
        this.audits_loading = false;
      }
    },

    map_audit_to_row(a) {
      return (a && typeof a === 'object')
        ? { t: String(this.extract_title(a)), d: this.build_description(a) || '-' }
        : null;
    },

    extract_title(audit) {
      return audit.date_created ||
             audit.action ||
             audit.event ||
             audit.type ||
             audit.category;
    },

    build_description(audit) {
      const bits = [
        audit.description || audit.message || audit.summary,
        audit.entity || audit.object || audit.target,
        audit.status,
        audit.duration ? String(audit.duration) : null,
        this.format_date(audit.created_at || audit.timestamp || audit.time),
      ].filter(Boolean);
      return bits.join(' - ');
    },

    update_progress_bar() {
      const bars = Array.isArray(this.$refs.storage_progress_bar)
        ? this.$refs.storage_progress_bar
        : [this.$refs.storage_progress_bar].filter(Boolean);

      bars.forEach(bar => {
        bar.style.width = `${this.percentage_used || 0}%`;
      });
    },

    async fetch_storage_stats() {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/aic_drive/get_storage_stats/`;
      const token = get_token();

      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      try {
        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${token}`,
            "X-Page-URL": window.location.href,
            "X-CSRFToken": this.csrfToken
          },
        });

        if (!res.ok) {
          if (res.status === 401) {
            this.$router.push({ name: 'Login' });
            return;
          }
          const data = await res.json();
          console.error(data.message || `Failed to fetch storage stats: HTTP ${res.status}`);
          return;
        }

        const data = await res.json();
        if (data.status === "success") {
          const stats = data.data;

          this.used_gb = stats.used_gb;
          this.total_gb = stats.total_gb;
          this.available_gb = stats.available_gb;
          this.percentage_used = stats.percentage_used;
        } else {
          this.$notyf.error("Error fetching storage stats:", data.message || "Unknown error");
        }
      } catch (err) {
        console.error("Network error:", err);
      }
    },

    format_date(d) {
      if (!d) return null;
      try {
        const dt = new Date(d);
        if (isNaN(dt.getTime())) return null;
        return dt.toLocaleString();
      } catch {
        return null;
      }
    },

    go_to_page(url) {
      if (url) {
        window.location = url;
      } else {
        this.$notyf.info("No page URL available");
      }
    },

    async fetch_engagenet_events() {
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_engagenet_events/`;

      try {
        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${token}`,
            "X-CSRFToken": this.csrfToken
          },
        });

        const json = await res.json();

        if (!res.ok || json.status !== "success") {
          this.upcoming_events = [];
          return;
        }

        let events_container = null;

        if (
          Reflect.has(json, "events") &&
          json.events &&
          Reflect.has(json.events, "data") &&
          json.events.data &&
          Reflect.has(json.events.data, "results")
        ) {
          events_container = json.events.data.results;
        }

        if (Array.isArray(events_container)) {
          this.upcoming_events = events_container.map(ev => ({
            id: ev.id || null,
            event_name: ev.event_name || "",
            start_date: ev.start_date || "",
          }));

          this.upcoming_events.sort((a, b) => {
            const date_a = new Date(a.start_date).getTime();
            const date_b = new Date(b.start_date).getTime();
            return date_a - date_b;
          });

        } else {
          this.upcoming_events = [];
        }

      } catch (err) {
        console.error("Event fetch failed:", err);
        this.upcoming_events = [];
      }
    },

    async fetch_engagenet_document_approvals() {
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_engagenet_document_approvals/`;

      try {
        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Authorization": `Token ${token}`,
            "Content-Type": "application/json",
            "X-CSRFToken": this.csrfToken
          },
        });

        const json = await res.json();

        if (json.status !== "success") {
          this.pending_approvals = 0;
          return;
        }

        const docs = json.approvals?.data || [];
        this.pending_approvals = docs.length;

      } catch (err) {
        console.error("Document approval fetch failed:", err);
        this.pending_approvals = 0;
      }
    },

    async fetch_engagenet_notifications() {
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_engagenet_notifications/`;

      try {
        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Authorization": `Token ${token}`,
            "Content-Type": "application/json",
            "X-CSRFToken": this.csrfToken
          },
        });

        const json = await res.json();

        if (!res.ok || json.status !== "success") {
          this.notification_count = 0;
          this.notifications = [];
          return;
        }

        this.notifications = json.notifications?.data ?? [];
        this.notification_count = json.notifications?.count ?? 0;

      } catch (err) {
        console.error("Engagenet notifications fetch failed:", err);
        this.notification_count = 0;
        this.notifications = [];
      }
    },

    async fetch_user_courses() {
      this.courses_loading = true;
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_user_courses/`;
      const token = get_token();

      if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      try {
        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${token}`,
            "X-CSRFToken": this.csrfToken,
          },
        });

        if (!res.ok) {
          if (res.status === 401) {
            this.$router.push({ name: 'Login' });
            return;
          }
          const data = await res.json();
          console.error(data.message || `Failed to fetch courses: HTTP ${res.status}`);
          return;
        }

        const response = await res.json();

        // Handle the nested data structure
        if (response.status === "success" && response.data) {
          // Store user information if needed
          this.user = {
            ...this.user,
            external_user_id: response.data.external_user_id,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            email: response.data.email,
            name: `${response.data.first_name} ${response.data.last_name}`

          };
          this.user_first_name = response.data.first_name || 'there';

          // Store courses array
          this.courses = response.data.courses || [];

        } else {
          console.error(response.message || "Error fetching courses");
        }
      } catch (err) {
        console.error("Network error fetching courses:", err);
      } finally {
        this.courses_loading = false;
      }
    },

    async fetch_pending_requests() {
      this.pending_requests_loading = true;
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_pending_requests/`;

      try {
        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Authorization": `Token ${token}`,
            "Content-Type": "application/json",
            "X-CSRFToken": this.csrfToken
          },
        });

        if (!res.ok) {
          if (res.status === 401) {
            this.$router.push({ name: 'Login' });
            return;
          }
          const data = await res.json();
          console.error(data.message || `Failed to fetch pending requests: HTTP ${res.status}`);
          this.pending_requests = 0;
          this.pending_requests_list = [];
          return;
        }

        const json = await res.json();

        if (json.status === "success") {
          this.pending_requests_list = json.data?.data || [];
          this.pending_requests = this.pending_requests_list.length;
        } else {
          console.error(json.message || "Error fetching pending requests");
          this.pending_requests = 0;
          this.pending_requests_list = [];
        }

      } catch (err) {
        console.error("Network error fetching pending requests:", err);
        this.pending_requests = 0;
        this.pending_requests_list = [];
      } finally {
        this.pending_requests_loading = false;
      }
    },

    async fetch_user_cases () {
      this.cases_loading = true;
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_cases_for_users/`;

      try {
        const res = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Authorization": `Token ${token}`,
            "Content-Type": "application/json",
            "X-CSRFToken": this.csrf_token
          },
        });

        if (!res.ok) {
          if (res.status === 401) {
            this.$router.push({ name: 'Login' });
            return;
          }
          const data = await res.json();
          console.error(data.message || `Failed to fetch cases: HTTP ${res.status}`);
          this.cases = [];
          this.pending_cases = 0;
          return;
        }

        const json = await res.json();

        if (json.status === "success") {
          this.cases = json.data?.data || [];
          this.pending_cases = this.cases.length;
        } else {
          console.error(json.message || "Error fetching cases");
          this.cases = [];
          this.pending_cases = 0;
        }

      } catch (err) {
        console.error("Network error fetching cases:", err);
        this.cases = [];
        this.pending_cases = 0;
      } finally {
        this.cases_loading = false;
      }
    },

   apply_user_tasks(tasks = []) {
      this.tasks = tasks;

      this.assigned_tasks_count = tasks.filter(task =>
        ['assigned', 'in_progress'].includes(
          String(task.status).toLowerCase()
        )
      ).length;

      this.overdue_tasks_count = tasks.filter(task =>
        String(task.status).toLowerCase() === 'overdue'
      ).length;

      this.completed_this_week = tasks.filter(task =>
        String(task.status).toLowerCase() === 'completed'
      ).length;

      this.active_tasks = this.assigned_tasks_count;
    },

    handle_user_tasks_response(json) {
      if (json.status === 'success') {
        this.apply_user_tasks(json.data ?? []);
      }
    },

    async fetch_user_tasks() {
      this.tasks_loading = true;
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_user_tasks/`;

      try {
        const res = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            Authorization: `Token ${token}`,
            'Content-Type': 'application/json',
            'X-CSRFToken': this.csrfToken,
          },
        });

        if (!res.ok) {
          this.tasks = [];
          return;
        }

        this.handle_user_tasks_response(await res.json());
      } catch (err) {
        console.error('Error fetching tasks:', err);
        this.tasks = [];
      } finally {
        this.tasks_loading = false;
      }
    },
  },
};
